module.exports = __webpack_public_path__ + "img/3-1-1.1162ac53.png";